export default __webpack_public_path__ + "static/media/Fee.6a58ef6e.svg";